'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const ThemeSettingsContext = createContext({});
export const ThemeSettingsProvider = ({ data, children }) => {
    return _jsx(ThemeSettingsContext.Provider, { value: data, children: children });
};
